var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDual = function SvgDual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dual_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".dual_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dual_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "dual_svg__st1",
    d: "M16 6.98H2c-1.1 0-2 .92-2 2.05v7.48h18V9.02c0-1.12-.9-2.04-2-2.04zM2 19.57h6v2.56H6c-.28 0-.5.23-.5.51s.22.51.5.51h6c.28 0 .5-.23.5-.51s-.22-.51-.5-.51h-2v-2.56h6c1.1 0 2-.92 2-2.05H0c0 1.14.9 2.05 2 2.05z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "dual_svg__st1",
    d: "M19 9.02v1.35h5V2.89c0-1.13-.9-2.05-2-2.05H8c-1.1 0-2 .92-2 2.05v3.07h10c1.65-.01 3 1.38 3 3.06zM22 13.43c1.1 0 2-.92 2-2.05h-5v2.05h3z"
  })));
};
export default SvgDual;